var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepperNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5486",
    "data-name": "Group 5486",
    transform: "translate(0.283 0.476)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 14.5,
    cy: 15,
    rx: 14.5,
    ry: 15,
    transform: "translate(-0.283 -0.476)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(9.717 9.524)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperNormal);
export default __webpack_public_path__ + "static/media/stepper-normal.daa0443ad62bb1f07259384e68e2a4be.svg";
export { ForwardRef as ReactComponent };